module.exports = __webpack_public_path__ + "static/img/招标-4.a0ec6b5b.png";